'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Toggle } from '@workspace/ui';

interface NotificationsUnreadSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  hasUnread?: boolean;
}

export function NotificationsUnreadSwitch({
  value,
  onChange,
  hasUnread = false,
}: NotificationsUnreadSwitchProps) {
  const toggleHandler = (newValue: boolean) => {
    onChange(newValue);
  };

  return (
    <Toggle
      onChange={toggleHandler}
      label={'Unread'}
      value={value}
      defaultValue={false}
      disabled={!hasUnread && !value}
    />
  );
}
